import React from 'react'

import { Flex, styled } from '@driftt/dds'
import { Card } from '@driftt/tide-core'

import Google_Logo from 'layouts/SignupChoiceCard/google-logo.svg'
import Microsoft_Logo from 'layouts/SignupChoiceCard/microsoft-logo.svg'

const CardContainer = styled(Flex, {
  '& .tide-card': {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '80px',
    minHeight: '80px',
    height: '80px',
    width: '80px',
    padding: '8px',
    cursor: 'pointer',
    gap: '$half',
  },

  '& img': {
    width: '32px',
    height: '32px',
  },

  '& .tide-card--image': {
    marginBottom: '$0',
  },

  '& p': {
    margin: '0px!important', // override setup-container-fields global styles
  },
})

export const ThirdPartyCards = ({
  onGoogleCardClick,
  onMicrosoftCardClick,
}) => (
  <CardContainer direction="row">
    <Card
      description="Google"
      imgSrc={Google_Logo}
      onClick={onGoogleCardClick}
    />
    <Card
      imgSrc={Microsoft_Logo}
      description="Microsoft"
      onClick={onMicrosoftCardClick}
    />
  </CardContainer>
)
